import apiClient, { clearSessionToken } from '../Services/services';

export class ApiError extends Error {
  constructor(message, { status, data } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

/**
 * Auth-aware request wrapper.
 *
 * Uses the existing `apiClient` configuration from the login flow:
 * - Authorization bearer token (client_api gateway)
 * - X-Portal-Domain tenant resolution
 * - X-Session-Token session persistence (via existing interceptor)
 */
export async function request(config) {
  try {
    const response = await apiClient.request(config);
    return response.data;
  } catch (err) {
    const status = err?.response?.status;
    const data = err?.response?.data;

    // If the session is no longer valid, clear it so the existing app flow can re-auth.
    if (status === 401) {
      clearSessionToken();
    }

    const message =
      data?.error ||
      data?.message ||
      err?.message ||
      'Request failed';

    throw new ApiError(message, { status, data });
  }
}

